import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractCycleDateService } from '../abstraction/abstract.cycle-date.service';

@Injectable({
  providedIn: 'root',
})
export class CycleDateService extends AbstractCycleDateService {
  controller = `/manager/cycledate`;
  urlGetCurrentCycleDate = `${environment.apiUrl}${this.controller}/getcurrentcycledate`;

  constructor(private http: HttpClient) {
    super();
  }

  getCurrentCycleDate(): Promise<string | undefined> {
    return this.http.get<string>(`${this.urlGetCurrentCycleDate}`).toPromise();
  }
}
